import { toSimilarJob as toCommonSimilarJob } from "@repo/design-system/utils/to-similar-job";
import type { JobData, SimilarJob } from "~/types/job";

/**
 * Converts EON job data into an EON SimilarJob while preserving fields that
 * are required when an application URL is processed later.
 */
export function toSimilarJob(data: JobData): SimilarJob {
  return {
    ...toCommonSimilarJob(data),
    source: data.source,
    postingLanguages: data.postingLanguages ?? ["en"],
  };
}
